// extracted by mini-css-extract-plugin
module.exports = {"title":"clients-module--title--18Tyo","fontsLoading":"clients-module--fonts-loading--CcUtX","image":"clients-module--image--1HnVk","logos":"clients-module--logos--3LVyY"};